<template>
    <div>
        <div class="steps">
            <div
                    class="step"
                    v-for="tab in tabs"
                    :class="{ 'active': tab.isActive, 'completed' : tab.isCompleted, 'has-icon': tab.icon }"
                    :key="tab.name"
            >
                <div class="v-stepper">
                    <i
                            v-if="tab.icon"
                            class="tab-icon fal"
                            :class="[tab.icon ? 'fa-' + tab.icon : '' ]"
                    />
                    <i
                            v-if="!tab.icon && tab.isCompleted"
                            class="far fa-check"
                    />
                    <div
                            v-if="!tab.icon && !tab.isCompleted"
                            class="circle"
                    />
                    <div class="line" />
                </div>

                <div class="content">
                    {{ tab.name }}
                </div>
            </div>
        </div>
        <div class="main-content">
            <b-container>
                <b-col md="12">
                    <div class="tab-details">
                        <slot :formData="formData" />
                    </div>
                </b-col>
                <b-row class=" justify-content-center align-self-center prev-next">
                    <b-col class="btn-prev-next">
                        <div
                                class="control"
                                v-if="currentActive > 0"
                        >
                            <b-button
                                    @click="previousTab()"
                                    block
                                    variant="secondary"
                                    size="lg"
                            >
Prev
                            </b-button>
                        </div>
                    </b-col>
                    <b-col class="align-self-center">
                        <div class="prev-next-line" />
                    </b-col>
                    <b-col class="btn-prev-next">
                        <div
                                class="control"
                                v-if="currentActive < totalTabs - 1"
                        >
                            <b-button
                                    block
                                    variant="warning"
                                    size="lg"
                                    @click="nextTab()"
                            >
Next
                            </b-button>
                        </div>
                        <div
                                class="control"
                                v-if="currentActive == totalTabs -1"
                        >
                            <b-button
                                    block
                                    variant="warning"
                                    size="lg"
                            >
Save
                            </b-button>
                        </div>
                    </b-col>
</b-row>
            </b-container>
        </div>
</div>
</template>

<script>
    export default {
        name: 'VerticalStepper',
        data() {
            return {
                tabs: [],
                currentActive: 0,
                totalTabs: 0,
                formData: {
                    name: '',
                    email: '',
                    about: '',
                    gender: '',
                    reference: '',
                    terms: '',
                },

            };
        },
        created() {
            this.tabs = this.$children;
        },
        mounted() {
            this.totalTabs = this.tabs.length;
        },
        methods: {
            previousTab() {
                this.currentActive--;
                this.tabs.forEach(tab => {
                    tab.isActive = false;
                });

                this.tabs[this.currentActive].isCompleted = false;
                this.tabs[this.currentActive].isActive = true;
            },
            nextTab() {
                this.currentActive++;
                this.tabs.forEach(tab => {
                    tab.isActive = false;
                    if (this.tabs[this.currentActive]._uid > tab._uid) {
                        tab.isCompleted = true;
                    }
                });

                this.tabs[this.currentActive].isActive = true;
            },

        },
    };
</script>

<style
        scoped
        lang="scss"
>

    .main-content {
        background: #123D64;
        color:      white;
        min-height: 100vh;
    }

</style>
